/**
 * Copyright Motili Inc., 2016 All Rights Reserved
 */

// TODO: This component has not been updated to follow the 'common' component paradigm

/* eslint-disable no-useless-constructor */

import { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import FormLabel from 'common/components/form/FormLabel';

/**
 * FormEmailInput
 *
 * Standard Motili Password Input for use within a form
 *
 */
export default class FormPasswordInput extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const _label = this.props.noLabel ? null : (
            <FormLabel
                label={this.props.label || 'Password'}
                style={this.props.labelStyle}
            />
        );
        return (
            <Form.Group controlId={this.props.controlId}>
                {_label}
                <FormControl
                    type='password'
                    value={this.props.value}
                    placeholder={this.props.placeholder || 'Password'}
                    onChange={this.props.onChange}
                    style={{
                        borderRadius: 0,
                    }}
                />
            </Form.Group>
        );
    }
}

FormPasswordInput.propTypes = {
    controlId: PropTypes.string,
};

FormPasswordInput.defaultProps = {
    controlId: 'passwordInput',
};
